"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.directionCache = exports.StencilProvider = exports.StencilContext = exports.StencilConsumer = exports.STENCIL_CONTEXT_PROPS = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _cache = _interopRequireDefault(require("@emotion/cache"));

var _core = require("@emotion/core");

var _emotionTheming = require("emotion-theming");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _stylisPluginRtl = _interopRequireDefault(require("stylis-plugin-rtl"));

var _stencilReactThemeDefault = _interopRequireDefault(require("@amzn/stencil-react-theme-default"));

var _utils = require("../responsive/utils");

var _isHighContrast = _interopRequireDefault(require("../utils/isHighContrast"));

var _liveAnnouncer = require("../live-announcer");

var _GetGlobalVariables = require("./GetGlobalVariables");

var _GlobalCSS = require("./GlobalCSS");

var _StencilDialogContext = require("./StencilDialogContext");

var _FontLoader = require("./font-loader/FontLoader");

var _themeSelectors = require("./themeSelectors");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var directionCache = {
  rtl: (0, _cache.default)({
    key: 'css-rtl',
    stylisPlugins: [_stylisPluginRtl.default]
  }),
  ltr: (0, _cache.default)({
    key: 'css'
  })
};
exports.directionCache = directionCache;

var DirectionWrapper = function DirectionWrapper(_ref) {
  var isRTL = _ref.isRTL,
      children = _ref.children;

  if (isRTL) {
    return (0, _core.jsx)("div", {
      dir: "rtl"
    }, children);
  }

  return (0, _core.jsx)(_react.default.Fragment, null, children);
};

var StencilContext = /*#__PURE__*/(0, _react.createContext)({
  theme: _stencilReactThemeDefault.default,
  locale: 'en',
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setTheme: function setTheme(_) {
    return null;
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setLocale: function setLocale(_) {
    return null;
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setIsRTL: function setIsRTL(_) {
    return null;
  },
  // @ts-ignore There's no sensible default for 'selectors'
  selectors: {}
});
exports.StencilContext = StencilContext;
var STENCIL_CONTEXT_PROPS = ['theme', 'setTheme', 'selectors'];
exports.STENCIL_CONTEXT_PROPS = STENCIL_CONTEXT_PROPS;

var StencilProvider = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(StencilProvider, _Component);

  var _super = _createSuper(StencilProvider);

  function StencilProvider() {
    var _this;

    (0, _classCallCheck2.default)(this, StencilProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      theme: _this.props.theme || _stencilReactThemeDefault.default,
      locale: _this.props.locale || 'en',
      isRTL: _this.props.isRTL || false,
      isInHighContrast: (0, _isHighContrast.default)()
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "selectors", {
      color: _this.bindTheme(_themeSelectors.selectColor),
      colorOrNull: _this.bindTheme(_themeSelectors.selectColorOrNull),
      fontFamily: _this.bindTheme(_themeSelectors.selectFontFamily),
      fontSize: _this.bindTheme(_themeSelectors.selectFontSize),
      lineHeight: _this.bindTheme(_themeSelectors.selectLineHeight),
      fontWeight: _this.bindTheme(_themeSelectors.selectFontWeight),
      space: _this.bindTheme(_themeSelectors.selectSpace),
      breakpoint: _this.bindTheme(_themeSelectors.selectBreakpoint),
      zIndex: _this.bindTheme(_themeSelectors.selectZIndex),
      constant: _this.bindTheme(_themeSelectors.selectConstant),
      radius: _this.bindTheme(_themeSelectors.selectRadius)
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setTheme", function (theme) {
      _this.setState({
        theme: theme
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setLocale", function (locale) {
      _this.setState({
        locale: locale
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setIsRTL", function (isRTL) {
      _this.setState({
        isRTL: isRTL
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getCache", function (isRTL) {
      return isRTL ? directionCache.rtl : directionCache.ltr;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "mediaQueries", {
      sm: _this.getMediaQueryFn(_this.selectors.breakpoint('s')),
      md: _this.getMediaQueryFn(_this.selectors.breakpoint('m')),
      lg: _this.getMediaQueryFn(_this.selectors.breakpoint('l')),
      xl: _this.getMediaQueryFn(_this.selectors.breakpoint('xl'))
    });
    return _this;
  }

  (0, _createClass2.default)(StencilProvider, [{
    key: "bindTheme",
    value: function bindTheme(selector) {
      var _this2 = this;

      return function () {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return selector.apply(void 0, [_this2.state.theme].concat(args));
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          locale = _this$props.locale,
          theme = _this$props.theme;

      if (!!theme && theme !== prevProps.theme) {
        this.setState({
          theme: theme
        });
      }

      if (!!locale && locale !== prevProps.locale) {
        this.setState({
          locale: locale
        });
      }
    }
  }, {
    key: "getMediaQueryFn",
    value: function getMediaQueryFn(breakpoint) {
      return function (breakpointStyles) {
        return (0, _defineProperty2.default)({}, (0, _utils.buildMediaQuery)(breakpoint, true), breakpointStyles);
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          emberUrl = _this$props2.emberUrl,
          emotionCache = _this$props2.emotionCache,
          shouldAddLiveAnnouncer = _this$props2.shouldAddLiveAnnouncer,
          shouldUseResponsiveText = _this$props2.shouldUseResponsiveText,
          mode = _this$props2.mode,
          isNested = _this$props2.isNested;
      var _this$state = this.state,
          theme = _this$state.theme,
          locale = _this$state.locale,
          isRTL = _this$state.isRTL,
          isInHighContrast = _this$state.isInHighContrast;
      var setTheme = this.setTheme,
          setLocale = this.setLocale,
          setIsRTL = this.setIsRTL,
          selectors = this.selectors,
          mediaQueries = this.mediaQueries,
          getCache = this.getCache;
      var emotionTheme = {
        isInHighContrast: isInHighContrast,
        isRTL: isRTL,
        mode: mode,
        selectors: selectors,
        shouldUseResponsiveText: shouldUseResponsiveText,
        values: theme,
        mediaQueries: mediaQueries,
        utils: {
          mergeStyles: _utils.mergeStyles
        }
      };
      var globalCSS = (0, _GlobalCSS.getGlobalCSS)(theme);
      var globalVariables = (0, _GetGlobalVariables.getGlobalVariables)(emotionTheme);
      var content = (0, _core.jsx)(_react.default.Fragment, null, shouldAddLiveAnnouncer ? (0, _core.jsx)(_liveAnnouncer.LiveAnnouncer, null, children) : children, !isNested && (0, _core.jsx)(_FontLoader.FontLoader, {
        emberUrl: emberUrl
      }), !isNested && (0, _core.jsx)(_core.Global, {
        styles: globalCSS
      }), !isNested && (0, _core.jsx)(_core.Global, {
        styles: globalVariables
      }));
      return (0, _core.jsx)(StencilContext.Provider, {
        value: {
          isRTL: isRTL,
          locale: locale,
          mode: mode,
          selectors: selectors,
          setLocale: setLocale,
          setIsRTL: setIsRTL,
          setTheme: setTheme,
          theme: theme,
          isInHighContrast: isInHighContrast
        }
      }, (0, _core.jsx)(DirectionWrapper, {
        isRTL: isRTL
      }, (0, _core.jsx)(_StencilDialogContext.StencilDialogProvider, null, (0, _core.jsx)(_emotionTheming.ThemeProvider, {
        theme: emotionTheme
      }, (0, _core.jsx)(_core.CacheProvider, {
        value: getCache(isRTL)
      }, !!emotionCache ? (0, _core.jsx)(_core.CacheProvider, {
        value: emotionCache
      }, content) : content)))));
    }
  }]);
  return StencilProvider;
}(_react.Component); // Only the Context object can have a display name, not the consumer.
// The consumer will automatically be named `${Context.displayName}.Consumer`


exports.StencilProvider = StencilProvider;
(0, _defineProperty2.default)(StencilProvider, "displayName", 'StencilProvider');
(0, _defineProperty2.default)(StencilProvider, "propTypes", {
  theme: _propTypes.default.any,
  emberUrl: _propTypes.default.string,
  shouldAddLiveAnnouncer: _propTypes.default.bool,
  shouldUseResponsiveText: _propTypes.default.bool,
  mode: _propTypes.default.oneOf(['default', 'dense']),
  locale: _propTypes.default.string,
  isRTL: _propTypes.default.bool,
  isNested: _propTypes.default.bool
});
(0, _defineProperty2.default)(StencilProvider, "defaultProps", {
  theme: _stencilReactThemeDefault.default,
  shouldAddLiveAnnouncer: true,
  shouldUseResponsiveText: true,
  mode: 'default',
  isRTL: false,
  isNested: false
});
StencilContext.displayName = 'StencilContext';
var StencilConsumer = StencilContext.Consumer;
exports.StencilConsumer = StencilConsumer;